import type { AnnouncementStep, NightRoleStep, RoleId } from "../types";
import { ROLE_DEFINITIONS } from "../types";

export function countRoles(
  roleIds: readonly RoleId[],
): ReadonlyMap<RoleId, number> {
  const counts = new Map<RoleId, number>();
  for (const roleId of roleIds) {
    counts.set(roleId, (counts.get(roleId) ?? 0) + 1);
  }
  return counts;
}

export function buildNightRoleQueue(
  roleIds: readonly RoleId[],
  actorPlayerIdsByRole: ReadonlyMap<RoleId, readonly string[]> = new Map(),
): readonly NightRoleStep[] {
  return [...new Set(roleIds)]
    .filter((roleId) => ROLE_DEFINITIONS[roleId].wakesAtNight)
    .sort((a, b) => {
      const left = ROLE_DEFINITIONS[a].nightOrder ?? Number.MAX_SAFE_INTEGER;
      const right = ROLE_DEFINITIONS[b].nightOrder ?? Number.MAX_SAFE_INTEGER;
      return left - right;
    })
    .map((roleId) => {
      const actorPlayerIds = actorPlayerIdsByRole.get(roleId) ?? [];
      return {
        roleId,
        status: actorPlayerIds.length > 0 ? "pending" : "complete",
        actorPlayerIds,
        completedPlayerIds: [],
      };
    });
}

export function buildAnnouncementTimeline(
  roleIds: readonly RoleId[],
): readonly AnnouncementStep[] {
  return buildNightRoleQueue(roleIds).map((step) => ({
    roleId: step.roleId,
    scriptKey: `night.${step.roleId}`,
    status: "pending",
  }));
}
